import React, {
  useEffect,
  useRef,
  useState,
  memo,
  Suspense
} from 'react';
import { MagicApronAssistant } from '@thd-olt-component-react/magic-apron';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { ExperienceProvider, ContextBuilder } from '@thd-nucleus/experience-context';
import { useDesktopBreakpoint } from '../../utils/headerUtils';

const MAHeaderWrapper = () => {

  const [storeId, setStoreId] = useState('121');
  const [deliveryZip, setDeliveryZip] = useState('30339');
  const localizerRef = useRef(null);
  const isDesktop = useDesktopBreakpoint();

  const {
    experienceContext
  } = ContextBuilder.client({
    expConfiguration: window?.__EXPERIENCE_PROPS__?.expConfiguration
  });

  useEffect(() => {
    import('Localizer')
      .then((localizer) => {
        localizerRef.current = localizer;
        const localizedStore = localizerRef.current.getLocalizedStore();
        if (localizedStore && localizedStore.storeId) {
          setStoreId(localizedStore.storeId);
        }
        const deliveryZipDetails = localizerRef.current.getDeliveryZipcodeDetails();
        if (deliveryZipDetails && deliveryZipDetails.zipcode) {
          setDeliveryZip(deliveryZipDetails.zipcode);
        }
      })
      // eslint-disable-next-line no-console
      .catch((error) => console.warn(`Error occurred while loading Localizer - ${error}`));
  }, []);

  return (
    <ExperienceProvider
      value={{
        ...experienceContext,
        channel: !isDesktop ? 'mobile' : 'desktop',
        hosts: { apionline: 'https://apionline.homedepot.com' },
        store: { storeId },
        deliveryZip
      }}
    >
      <QueryProvider cacheKey="magic-apron-header">
        <ErrorBoundary name="magic-apron-assistant-in-header">
          <Suspense fallback={null}>
            <MagicApronAssistant withPortal />
          </Suspense>
        </ErrorBoundary>
      </QueryProvider>
    </ExperienceProvider>
  );
};

MAHeaderWrapper.displayName = 'MAHeaderWrapper';

export default memo(MAHeaderWrapper);